/** @jsx jsx */ /** @jsxRuntime classic */

import React, { useState } from 'react';
import { jsx } from "theme-ui";

const EventCard = (props) => {
  const months = { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "May", 6: "Jun", 7: "Jul", 8: "Aug", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dec" };
  const [isHovered, setIsHovered] = useState(false);

  const cardStyle = {
    background: 'white',
    border: isHovered ? '1px solid #6E4884' : '1px solid #d5b3e7',
    borderRadius: '20px',
    boxShadow: isHovered ? '5px 5px 15px grey' : '0 4px 12px rgba(0, 0, 0, 0.2)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    cursor: 'pointer',
    color: '#6E4884',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  };

  const purpleHeader = {
    height: '100px',
    width: '100%',
    background: '#D5B3E7',
  }

  const textContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    flex: '1 1 auto',
    minWidth: '0',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingTop: '3%',
    marginBottom: '7%',
    textAlign: 'left',
  };

  const dateTimeContainer = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    flex: 0.3,
  };

  const monthStyle = {
    fontSize: '1.1vw',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#6E4884',
    marginBottom: '2px',
  };

  const dayStyle = {
    fontSize: '2.1vw',
    color: 'black',
    fontWeight: 'bold',
  };

  const infoContainer = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'flex-start',
    flex: 0.7,
    padding: '10px 15px',
    overflowWrap: 'anywhere',
  };

  const headingStyle = {
    fontSize: '1.2em',
    fontWeight: 'bold',
    marginBottom: '5px',
  };

  const timeText = {
    fontSize: '1em',
    marginBottom: '3px',
    color: 'grey',
    overflowWrap: 'anywhere',
  };

  const locationLink = {
    fontSize: '1.1em',
    wordWrap: 'break-word',
    overflowWrap: 'anywhere',
    color: '#6E4884',
    textDecoration: 'none',
  };

  return (
    <div style={cardStyle} onClick={props.onClick} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <div style={purpleHeader}></div>
      <div style={textContainerStyle}>
        
        {/* date section */}
        <div style={dateTimeContainer}>
          <h1 style={monthStyle}>{months[props.month]}</h1>
          <h1 style={dayStyle}>{props.day}</h1>
        </div>

        {/* event details */}
        <div style={infoContainer}>
          <h1 style={headingStyle}>{props.heading}</h1>
          <p style={timeText}>{`${props.startTime} - ${props.endTime}`}</p>
          <a style={locationLink}>{props.location && props.location.split(',')[0]}</a>
        </div>

      </div>
    </div>
  );
};

export default EventCard;